import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';
import { SubdomainService } from '../../../core/services/subdomain.service';
import { auth as AuthGen } from '@valvur/shared-grpc';

@Injectable({ providedIn: 'root' })
export class AdminService {
  #http = inject(HttpClient);
  #authService = inject(AuthService);
  #subdomain = inject(SubdomainService);

  admin = computed(() => this.#adminQuery.data());

  isLoading = computed(() => this.#adminQuery.isLoading());

  #adminQuery = injectQuery(() => ({
    queryKey: ['admin'],
    retry: 1,
    queryFn: () =>
      lastValueFrom(
        this.#http
          .get<AuthGen.User>(`${environment.baseUrl}/user/admin`)
          .pipe(take(1))
      ),
    enabled:
      this.#authService.isAuthenticated() &&
      this.#subdomain.isAdminSubdomain(),
  }));

  refetch(): void {
    this.#adminQuery.refetch();
  }
}
